



import { createApiCall } from 'services'
import { getErrorMessage } from 'utils'

import type { ActionCallback } from '../model'

import { AxiosResponse } from 'axios'
import { call, put, fork, takeLatest } from 'redux-saga/effects'

import { Actions, ITheme } from './types'




export function* getThemeSaga(): Generator {
  yield takeLatest(Actions.GET_THEME, function* (action: ActionCallback<{ id: string; styles: ITheme }>) {
    try {
      const { payload, callback } = action

      const { data, status } = yield call(createApiCall, {
        url: `/companies/public/${payload.id}/settings/style`,
      })

      if (status === 200) {
        yield put({
          type: Actions.SET_THEME,
          payload: data.styles,
        })
      }

      callback && callback({ success: true, content: data })
    } catch (e) {
      console.error(e)
      action.callback && action.callback({ success: false, content: getErrorMessage(e) })
    }
  })
}

export function* editThemeSaga(): Generator {
  yield takeLatest(Actions.EDIT_THEME, function* (action: ActionCallback<{ id: string }>) {
    const { payload, callback } = action
    try {
      const response: AxiosResponse = yield call(createApiCall, {
        method: 'PUT',
        url: `/companies/admin/${payload.id}/settings`,
        data: payload,
      })

      const { data, status } = response

      callback && callback({ success: true, content: data })
    } catch (e) {
      console.warn(e)
      callback && callback({ success: false, content: getErrorMessage(e) })
    }
  })
}

export default [fork(getThemeSaga), fork(editThemeSaga)]
